module.exports = __webpack_public_path__ + "static/home-hero-300313c0ccbe0b31899fdae6d4c3a6dd.jpg";